import s from "../sidebar.module.sass";
import type { SidebarBorrower, SidebarBook } from "./types";
import { int } from "@/lib/format";

export function BorrowerHeader({ borrower, activeBook }: {
  borrower: SidebarBorrower;
  activeBook: SidebarBook | null;
}) {
  return (
    <div className={s.facilityBlock}>
      <div className={s.facilityName}>{borrower.legal_name}</div>
      <div className={s.facilityMeta}>
        {[borrower.country, borrower.kyc_status, borrower.currency].filter(Boolean).join(", ")}
      </div>
      {activeBook && (
        <div className={s.facilityKpis}>
          <div>
            <div className={s.kpiLabel}>LOANS</div>
            <div className={s.kpiValue}>{int(activeBook.loan_count)}</div>
          </div>
          <div>
            <div className={s.kpiLabel}>PAYMENTS</div>
            <div className={s.kpiValue}>{int(activeBook.payment_count)}</div>
          </div>
        </div>
      )}
    </div>
  );
}
